import {
  getPostApiV1ThreeLetterCodePartnerAdminsClientsMutationFetcher,
  getPostApiV1ThreeLetterCodePartnerAdminsClientsMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { PostApiV1ThreeLetterCodePartnerAdminsClients201 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * 利用企業作成APIを実行するカスタムフック
 *
 * @param threeLetterCode - パートナーコード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePostPartnerAdminsClients = (
  threeLetterCode: string,
  options?: {
    onSuccess?: (data: PostApiV1ThreeLetterCodePartnerAdminsClients201) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodePartnerAdminsClientsMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodePartnerAdminsClientsMutationFetcher(threeLetterCode),
    options
  );
};
